module.exports = __webpack_public_path__ + "img/IMG_8512_P_L_Wood.f9c36ccb.jpg";